export class WebError extends Error {
  constructor(message?: string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Error.stackTraceLimit = 20;
    super(message);
  }
}
